// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Niue from '../_raw/flag/icon_flag_niue.png';

export default () => <img src={Niue} alt="Niue" />;
